import { useEffect, useState } from 'react';
import { fetchModules } from '../api/methodsApi';
import useThrowAsyncError from '../../../hooks/useThrowAsyncError';
import { Module } from '../../../api/module';

function useModules(id?: string) {
  const handleError = useThrowAsyncError();

  const [modules, setModules] = useState<Module[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;

    setLoading(true);

    async function getModules(): Promise<void> {
      try {
        const modules = await fetchModules(id!);
        setModules(modules);
      } catch (e) {
        handleError(e);
      } finally {
        setLoading(false);
      }
    }

    getModules();
  }, [handleError, id]);

  function resetModules() {
    setModules([]);
  }

  return { modules, loading, resetModules };
}

export default useModules;
